<div class="flex h-screen bg-gray-100 overflow-hidden relative">
    <app-sidebar #mySidebar></app-sidebar>

    <div class="flex-grow flex flex-col min-h-screen transition-all duration-300 relative z-10"
         [ngClass]="mySidebar.isExpanded() ? 'md:ml-[284px]' : 'md:ml-[80px]'">

        <app-navbar></app-navbar>

        <main class="flex-grow flex flex-col w-full overflow-y-auto relative bg-gray-100">

            <div class="fixed bottom-0 right-0 pointer-events-none z-0 select-none overflow-hidden w-[40%] max-w-[530px]">
                <img
                    ngSrc="images/assets/asset-2.png"
                    alt="Background Decor"
                    width="530"
                    height="530"
                    priority
                    class="w-full h-auto opacity-80 translate-x-[15%] translate-y-[10%]"
                >
            </div>

            <div class="p-6 grow 2xl:p-12 relative z-10">
                <div class="max-w-[2560px] mx-auto">
                    <router-outlet />
                </div>
            </div>
        </main>
    </div>
</div>
